import { AvatarProps } from '@mantine/core';
import { forwardRef } from 'react';
import { User as UKUser, UserAvatar as UserAvatarWidget } from '@sinups/ui-kit';

type User = {
  Id?: number;
  Email?: string;
  Name?: string;
  FirstName?: string | null;
  SurName?: string | null;
  Surname?: string | null;
  MiddleName?: string | null;
};

export interface IUserAvatarProps extends AvatarProps {
  user?: User;
  src?: string | null;
  userId?: string | number;
  notClickable?: boolean;
}

function mapUser(user?: User, userId?: string, src?: string): UKUser | null {
  if (!user) return null;
  if (!userId && !user?.Id) return null;

  return {
    id: user.Id || Number(userId),
    email: user.Email || '',
    fullName: user.Name || '',
    firstName: user.FirstName || '',
    middleName: user.MiddleName || '',
    lastName: user.SurName || user.Surname || '',
    avatarUrl: src || ''
  };
}

export const UserAvatar = forwardRef<HTMLDivElement, IUserAvatarProps>(
  ({ user, src, userId, notClickable, ...props }, ref) => {
    const mappedUser = mapUser(user, userId?.toString(), src || '') || null;
    const fallback = `${user?.SurName || user?.Surname || ''} ${user?.FirstName || ''}`.trim();

    return (
      <UserAvatarWidget
        user={mappedUser}
        fallback={fallback}
        fallbackSrc={src || ''}
        ref={ref}
        avatarProps={{
          style: {
            cursor: notClickable ? 'default' : 'pointer'
          },
          ...props
        }}
      />
    );
  }
);

UserAvatar.displayName = 'UserAvatar';
